import React, { useEffect, useState } from "react";

// Router
import { Outlet } from "react-router-dom";

// Components:
import Stack from "../components/mui/Stack";
import TopbarMenu from "../components/layout/TopbarMenu";
import MagicContainer from "../components/common/MagicContainer";
import AppBar from "../components/layout/AppBar";

// Store
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import {
  setFilter,
  clearUser,
  setSelectedQuaterOptions,
} from "../store/slices/userSlice";
import { RootState } from "../store";

// Action
import {
  useProgramWithYearsQuery,
  useQuarterQuery,
} from "../store/apis/headerApi";
import NavigationBar from "../components/layout/NavigationBar";
import _get from "lodash/get";

// Routing
import { useLocation, useNavigate } from "react-router-dom";
import usePermission from "../helper/usePermission";
import helperMethods from "../helper/helperMethods";
import NoUserAccess from "../pages/NoUserAccess";

const LayoutContainer = () => {
  // Actions
  const { data: programWithYears = { programs: [] } } =
    useProgramWithYearsQuery({});
  const { data: quarterData = [] } = useQuarterQuery({});

  const [selectedYearsQuaterOptions, setSelectedYearsQuaterOptions] = useState<
    any[]
  >([]);

  // hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(
    (state: RootState) => state.user?.userDetails
  );
  const selectedOuaterOptions = useAppSelector(
    (state: RootState) => state.user?.selectedQuaterOptions
  );
  const userEmailAndName: any = useAppSelector(
    (state: RootState) => state.user?.user
  );

  const username = userEmailAndName?.username || "";
  const email = userEmailAndName?.email || "";

  const filter = useAppSelector((state: RootState) => state?.user?.filter);

  const isSelectQuarter =
    filter.selectedProgram !== undefined && filter.selectedYear !== undefined;

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleFilterSelect = (name: string, value: any = "") => {
    let filterOptions: any = {};
    filterOptions[name] = value;

    if (name === "selectedYear" && value) {
      filterOptions.selectedQuarter = null;
      if (value.quarterMaster?.length > 0) {
        dispatch(setSelectedQuaterOptions(value.quarterMaster));
      } else {
        dispatch(setSelectedQuaterOptions([]));
      }
    }

    if (!value) {
      if (name === "selectedProgram") {
        filterOptions = {
          selectedProgram: value,
          selectedYear: null,
          selectedQuarter: null,
        };
      } else if (name === "selectedYear") {
        filterOptions = {
          selectedYear: value,
          selectedQuarter: null,
        };
        if (value.quarterMaster?.length > 0) {
          dispatch(setSelectedQuaterOptions(value.quarterMaster));
        } else {
          dispatch(setSelectedQuaterOptions([]));
        }
      }
    }
    dispatch(setFilter(filterOptions));
  };

  const userDetailsObj = {
    username: _get(userDetails, "username", username || ""),
    email: _get(userDetails, "email", email || ""),
  };

  const handleLogoutClick = async () => {
    dispatch(clearUser());
    navigate("/");
  };

  useEffect(() => {
    if (programWithYears && !filter?.selectedProgram?.value) {
      dispatch(
        setFilter({
          selectedProgram: {
            label: programWithYears?.programs[0]?.label,
            value: programWithYears?.programs[0]?.value,
          },
        })
      );
    }

    if (quarterData && !filter?.selectedYear?.value) {
      if (!selectedOuaterOptions?.length) {
        if (quarterData[0]?.quarterMaster?.length > 0) {
          dispatch(setSelectedQuaterOptions(quarterData[0]?.quarterMaster));
        } else {
          dispatch(setSelectedQuaterOptions([]));
        }
      }
      dispatch(
        setFilter({
          selectedYear: {
            label: quarterData[0]?.year,
            value: quarterData[0]?.ProgramYearId,
          },
          selectedQuarter: {
            quarterMasterId: quarterData[0]?.quarterMaster[0]?.quarterMasterId,
            quarterMasterName:
              quarterData[0]?.quarterMaster[0]?.quarterMasterName,
          },
        })
      );
    }
  }, [
    programWithYears?.programs?.length,
    quarterData?.length,
    quarterData?.[0]?.quarterMaster?.length,
  ]);

  const { permissions } = usePermission();

  const userAccess = helperMethods.userNavigationTabAccess(permissions);

  const handleUserAccess = (data: any) => {
    for (const key in data) {
      if (data[key]) {
        return true;
      }
    }
    return false;
  };

  return (
    <Stack sx={{ minHeight: "100vh", backgroundColor: "#FFFBE9" }}>
      {/* Top menu */}
      <TopbarMenu
        handleLogoutClick={handleLogoutClick}
        userDetails={userDetailsObj}
        ProgramAndYearFilter={programWithYears}
        quarterFilter={quarterData}
        handleDrawerToggle={handleDrawerToggle}
        handleFilterSelect={handleFilterSelect}
        preSelectedFilter={filter}
        isSelectQuarter={isSelectQuarter}
        selectedYearsQuaterOptions={selectedOuaterOptions}
      />
      {handleUserAccess(userAccess) ? (
        <>
          {/* Top Navigation bar */}
          <MagicContainer sx={{ p: "0 !important" }}>
            <NavigationBar />
          </MagicContainer>

          {/* Body */}
          <MagicContainer sx={{ py: { xs: 1, md: 2 } }}>
            <Outlet />
          </MagicContainer>
        </>
      ) : (
        <NoUserAccess />
      )}
    </Stack>
  );
};

export default LayoutContainer;
